import { Injectable } from '@angular/core';
import { Firestore, doc, onSnapshot } from '@angular/fire/firestore';
import { User } from '../models/user.model';
import { DataService } from './data';
import { Observable } from 'rxjs';
import { resolveLoggedInDisplayName } from '../helpers/user-display-name.helper';

@Injectable({
  providedIn: 'root'
})
export class CurrentUserService {
  private currentUserUnsubscribe: (() => void) | null = null;

  constructor(
    private firestore: Firestore,
    private dataService: DataService,
  ) { }

  /**
   * Inicia la escucha en tiempo real del usuario autenticado y actualiza dataService
   * @param churchId ID de la iglesia
   * @param userId UID del usuario autenticado
   */
  listenForCurrentUser(churchId: string, userId: string): Observable<User | null> {
    if (this.currentUserUnsubscribe) {
      this.currentUserUnsubscribe();
      this.currentUserUnsubscribe = null;
    }
    return new Observable<User | null>(observer => {
      const userDocRef = doc(this.firestore, `iglesias/${churchId}/usuarios/${userId}`);
      this.currentUserUnsubscribe = onSnapshot(userDocRef, snap => {
        if (snap.exists()) {
          const userData = { ...snap.data(), id: snap.id } as unknown as User;
          this.dataService.setCurrentUserData([userData]);
          const resolved = resolveLoggedInDisplayName({
            user: userData,
            authDisplayName: this.dataService.getCurrentDisplayName(),
          });
          if (resolved) {
            this.dataService.setCurrentDisplayName(resolved);
          }
          observer.next(userData);
        } else {
          this.dataService.setCurrentUserData([]);
          observer.next(null);
        }
      }, error => {
        observer.error(error);
      });
      // Cleanup
      return () => {
        if (this.currentUserUnsubscribe) {
          this.currentUserUnsubscribe();
          this.currentUserUnsubscribe = null;
        }
      };
    });
  }

  // Deja de escuchar cambios en el usuario actual (se puede llamar, por ejemplo, en logout)
  unsubscribeCurrentUser() {
    if (this.currentUserUnsubscribe) {
      this.currentUserUnsubscribe();
      this.currentUserUnsubscribe = null;
    }
  }
}
